import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom-v5-compat";
import { FlightShopSelectors } from "@b2bportal/core-flights";
import { PackageNavigationFlow, PackageSteps } from "@b2bportal/core-utilities";

export const useRbcPackageFlightReturnPageRoute = () => {
  const navigate = useNavigate();

  const hasSelectedDepartureFlight = useSelector(
    FlightShopSelectors.hasSelectedDepartureFlights
  );

  const { fullRouteWithCurrentQueryParams } =
    PackageNavigationFlow.useGetStepRoute(PackageSteps.FLIGHT_DEPARTURE);

  useEffect(() => {
    // Navigate back to departure page if no departure flight is selected
    if (!hasSelectedDepartureFlight) {
      navigate(fullRouteWithCurrentQueryParams, { replace: true });
    }
    // Should check on initial render only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
